import React, { useRef } from 'react';
import { Navigation } from 'swiper/modules';
import { Swiper } from 'swiper/react';
import classNames from 'classnames';
import { FlyingSliderArrow, FlyingSliderArrowTypesEnum } from '../../../../../shared/src/components/FlyingSliderArrow';
import './GridPageStripGamesSwiper.css';
import {
    GtmEventComponent,
    GtmEventLocation,
} from '../../../../../shared/src/components/google-tag-manager/enums/gtm-event-enum';
import { useCurrentVerticalData } from '../../../../../shared/src/hooks/use-current-vertical-data.hook';
import { useSwiperTracking } from '../../../../../shared/src/hooks/use-swiper-tracking.hook';

export const GridPageStripGamesSwiper = ({
    children,
    as: SwiperTag = Swiper,
    wrapperClassName = null,
    strip,
    ...swiperProps
}) => {
    const modules = [Navigation];
    const prevRef = useRef();
    const nextRef = useRef();

    const {
        pamGameVerticalID,
        currentVerticalType,
    } = useCurrentVerticalData();
    const {
        onTouchStartHandler,
        onArrowClickHandler,
        onSlideChangeHandler,
    } = useSwiperTracking({
        location: GtmEventLocation.GAME_GRID,
        component: GtmEventComponent.GRID_STRIP,
        verticalId: pamGameVerticalID,
        verticalType: currentVerticalType,
        grid_strip_source: 'games categories',
        game_vertical_id: pamGameVerticalID,
        game_vertical_type: currentVerticalType,
        grid_strip_type: strip.designType,
    });

    // update swiper's navigation when refs are ready
    const handleOnInit = (swiper) => {
        swiper.params.navigation.prevEl = prevRef.current;
        swiper.params.navigation.nextEl = nextRef.current;
        swiper.navigation.init();
        swiper.navigation.update();
    };

    const wrapperClass = classNames(
        'grid-page-strip-games-swiper-wrapper',
        {
            [wrapperClassName]: !!wrapperClassName,
        }
    );

    // FlyingSliderArrow should go before the swiper to make the ref ready when swiper is initializing
    return (
        <div className={wrapperClass}>
            <div className="grid-page-strip-games-swiper">
                <FlyingSliderArrow
                    extraClass="grid-pages-strip-navigation"
                    ref={prevRef}
                    onClick={onArrowClickHandler}
                />

                <FlyingSliderArrow
                    extraClass="grid-pages-strip-navigation"
                    ref={nextRef}
                    arrowType={FlyingSliderArrowTypesEnum.NEXT}
                    onClick={onArrowClickHandler}
                />

                <SwiperTag
                    roundLengths={true}
                    modules={modules}
                    spaceBetween={10}
                    slidesPerView="auto"
                    navigation={false}
                    breakpoints={{
                        1024: {
                            spaceBetween: 16,
                            navigation: {
                                prevEl: prevRef.current,
                                nextEl: nextRef.current,
                            },
                        },
                    }}
                    onInit={handleOnInit}
                    onSlideChangeTransitionEnd={onSlideChangeHandler}
                    onTouchStart={onTouchStartHandler}
                    {...swiperProps}
                >
                    {children}
                </SwiperTag>
            </div>
        </div>
    );
};
